import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScreenshot = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M1.5 5.25V3.625C1.5 3.19402 1.6712 2.7807 1.97595 2.47595C2.2807 2.1712 2.69402 2 3.125 2H4.75",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.25 2H12.875C13.306 2 13.7193 2.1712 14.024 2.47595C14.3288 2.7807 14.5 3.19402 14.5 3.625V5.25",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5 10.75V12.375C14.5 12.806 14.3288 13.2193 14.024 13.524C13.7193 13.8288 13.306 14 12.875 14H11.25",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.75 14H3.125C2.69402 14 2.2807 13.8288 1.97595 13.524C1.6712 13.2193 1.5 12.806 1.5 12.375V10.75",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.8 5.5H5.2C4.8134 5.5 4.5 5.77982 4.5 6.125V9.875C4.5 10.2202 4.8134 10.5 5.2 10.5H10.8C11.1866 10.5 11.5 10.2202 11.5 9.875V6.125C11.5 5.77982 11.1866 5.5 10.8 5.5Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgScreenshot;
